export enum eAPITags {
  AdminDocuments = 'Admin Standard Documents',
  AdminUsersData = 'Admin Users Data',
  AdminUserRoles = 'Admin User Roles',
  ClientCompanyData = 'Client Company Data',
  DetailedEscrowData = 'Detailed Escrow Data',
  EnvironmentVariables = 'Environment Variables',
  FeesConnectedToEscrow = 'FeesConnectedToEscrow',
  IncomingACHActual = 'ACH Incoming Actual Entries By Query',
  IncomingACHExpected = 'ACHIncomingExpected',
  IncomingCheckActual = 'IncomingCheckActual',
  IncomingCheckExpected = 'IncomingCheckExpected',
  IncomingWireActual = 'IncomingWireActual',
  IncomingWireExpected = 'IncomingWireExpected',
  EscrowBankAccounts = 'Escrow Bank Accounts',

  LenderCompanyData = 'Lender Company Data',
  OrderAttributes = 'Order Attributes by Key',
  OrderData = 'Order Data by Key',
  OrderDiscounts = 'Order Discounts by Key',
  RoleData = 'Role Data',
  SectionData = 'Feescrow - Section Data with children',
  SigningAppointmentData = 'Signing Appointment Data by Order Key',
  SigningAppointmentListData = 'Signing Appointment LIST Data',
  SigningAppointmentStatusData = 'Signing Appointment Status Data',
  SigningAppointmentTypeData = 'Signing Appointment Type Data',
  SigningAppointmentMethodData = 'Signing Appointment Method Data',
  SigningAppointmentProgressionsData = 'Signing Appointment Progressions Data',
  UserListByGetUserQuery = 'UserListByGetUserQuery',
  MobilityGroupData = 'Group Data for a single Mobility Group',
  TasksData = 'Tasks Data',
  Tags = 'Tags',
  OrderTagData = 'Tag Data by Order Key',
  RecentOrders = 'Recent Orders',
  TransferDeed = 'Transfer Deed by order key',
  OrderPolicyPremiumDetails = 'Policy Premium Details by Order Key',

  FpeStatuses = 'Funding statuses',

  OrderInternalContacts = 'Internal Contacts by Order Key',
  OrderClientContacts = 'Client Contacts by Order Key',
  OrderLenderContacts = 'Lender Contacts by Order Key',
  OrderThirdPartyContacts = 'Third Party Contacts by Order Key',
  OrderEmdAccessCodes = 'EMD Access Codes for Acorn by Order Key',

  OrderComments = 'Comments By Order Key And Scope',

  ACHAccountInformation = 'ACHAccountInformation',
  WireDisbursement = 'WireDisbursement',
  ACHDisbursement = 'ACHDisbursement',
  CheckDisbursement = 'CheckDisbursement',
  InternalTransferDisbursement = 'InternalTransferDisbursement',

  DocumentCategories = 'Document Categories',
  MaritalStatuses = 'Marital Statuses',
  ContactFunctions = 'Contact Functions',

  FeatureFlags = 'Feature Flags',
  Config = 'Config',
  OrdersByFilterParams = 'Orders By Filter Params',
  TasksByFilterParams = 'Tasks By Filter Params',
  SettlementAgents = 'SettlementAgents',
  Underwriters = 'Underwriters',
  ClientUsers = 'Client Users by Client ID',
  ClientDefaultContacts = 'Client Default Contacts by Client ID',
}
